
import { defineComponent, ref, onMounted} from "vue";

export default defineComponent({
  data() {
      return {
          invalidZip: false,
          zipCode: ''
      }
  },
  mounted() {
    this.setInitialText();
  },
  props: {
    zip: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false
    }
  },
  emits: { 
    updated (zip: string): boolean {
      return zip != null;
    }
  },
  methods: {
    validateZip(validateErrors: boolean) {
      let input = (this.$refs.zip as HTMLInputElement),
          isValid = input.checkValidity();

      if(validateErrors || isValid) {
        this.invalidZip = !isValid;
        this.zipCode = this.invalidZip ? '' : input.value;
      }

      return isValid;
    },
    setInitialText() {
      let input = (this.$refs.zip as HTMLInputElement);
      input.value = this.$props.zip ?? '';
    },
    onEnterKey(event, zipCode) {
      event.preventDefault();
      const isValid = this.validateZip(true);
      
      if(isValid) {
        this.onSubmit(zipCode);
      }
    }
  },
  setup(props, context) {
    const onSubmit = (zipCode): void => {
      context.emit("updated", zipCode);
    };

    return {
      onSubmit
    };
  }
});
